import { useEffect, useState } from 'react'
import { AXIOS_INSTANCE } from '@cocoonspace/sdk-js/axios-client/use-custom-instance'
import { getUserToken } from '@cocoonspace/shared/libs/firebase'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { TableCell, TableRow } from '@cocoonspace/ui/components/table'
import { cn } from '@cocoonspace/ui/lib/utils'
import { ChevronDownIcon, DownloadIcon } from 'lucide-react'
import { LocalizedLink as Link } from '~/components/localized-link'

import { useFormatPrice } from '~/hooks/use-format-price'

export const MonthTableRow = ({
	month,
	year,
	monthTotal,
	monthTotalWithVat,
	isOpen,
	onClick,
}: {
	month: number
	year: number
	monthTotal: number
	monthTotalWithVat: number
	isOpen: boolean
	onClick: () => void
}) => {
	const formatPrice = useFormatPrice()
	const [userToken, setUserToken] = useState<string | undefined>('')

	useEffect(() => {
		getUserToken().then(setUserToken)
	}, [])

	return (
		<TableRow
			className='divide-border/75 cursor-pointer items-center divide-dashed bg-slate-50 font-bold'
			onClick={onClick}
		>
			<TableCell colSpan={4}>
				<div className='flex items-center gap-2 capitalize'>
					<ChevronDownIcon className={cn({ '-rotate-90': !isOpen })} />
					{dateTimeUtils(`${year}-${month}-01`).format('MMMM YYYY')}
				</div>
			</TableCell>

			<TableCell className='text-right'>
				<span className='flex items-baseline justify-end gap-1'>
					<span className='font-bold'>{formatPrice(monthTotal, 'EUR')}</span>
					<span className='text-xxs font-normal'>HT</span>
				</span>
			</TableCell>

			<TableCell className='text-right'>
				<span className='flex items-baseline justify-end gap-1'>
					<span className='font-bold'>
						{formatPrice(monthTotalWithVat, 'EUR')}
					</span>
					<span className='text-xxs font-normal'>TTC</span>
				</span>
			</TableCell>

			<TableCell>
				<div className='flex items-center gap-2'>
					<Link
						href={[
							`${AXIOS_INSTANCE.defaults.baseURL}/invoices/download`,
							`?year=${year}`,
							`&month=${month}`,
							`&token=${userToken}`,
						].join('')}
						target='_blank'
					>
						<DownloadIcon />
					</Link>
				</div>
			</TableCell>
		</TableRow>
	)
}
